export const KINDE_EMAIL_CONNECTION_ID =
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
    ? 'conn_bb01d81ef2084e0a901d412454c6e9e2'
    : 'conn_c4e53dab6eb94a45aa0c2a3ef45e46f6';

export const KINDE_GMAIL_CONNECTION_ID =
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
    ? 'conn_118743635d434a58ad853a8c7cf368c2'
    : 'conn_fbaf3c3703354a68b316eb2a2f5297bf';

export const KINDE_APPLE_CONNECTION_ID =
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
    ? 'conn_0192551631b66dfd9d349684eef963da'
    : 'conn_018f087c58a0eadab6504d6b24c8e9e1';

export type KindeUser = {
  id: string;
  email: string | null;
  given_name: string | null;
  family_name: string | null;
  picture: string | null;
  properties?: {
    usr_city?: string;
    usr_industry?: string;
    usr_job_title?: string;
    usr_middle_name?: string;
    usr_postcode?: string;
    usr_salutation?: string;
    usr_state_region?: string;
    usr_street_address?: string;
    usr_street_address_2?: string;
  };
} | null;
